export default "__VITE_ASSET__BLNSjuP6__"